interface VersionInfo {
  major: number;
  minor: number;
  patch: number;
  environment: string;
}

// Manually update this version when needed
export const version: VersionInfo = {
  major: 1,
  minor: 6,
  patch: 0,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "local",
};

export function getEnvironmentColor(env: string) {
  switch (env) {
    case "production":
      return "bg-green-100 text-green-800";
    case "development":
      return "bg-yellow-100 text-yellow-800";
    case "local":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function formatVersion(version: VersionInfo): string {
  return `Beta v${version.major}.${version.minor}.${version.patch}`;
}
